import { render, staticRenderFns } from "./GameSelect.vue?vue&type=template&id=27d7a7d9&scoped=true"
import script from "./GameSelect.vue?vue&type=script&lang=js"
export * from "./GameSelect.vue?vue&type=script&lang=js"
import style0 from "./GameSelect.vue?vue&type=style&index=0&id=27d7a7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7a7d9",
  null
  
)

export default component.exports